// client/src/pages/LoginPage.js

import React, { useState, useEffect } from "react"; 
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Container } from "react-bootstrap";
import LoginForm from "../components/LoginForm";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  
  const { user, login } = useAuth(); // ✅ Get the user from context
  const navigate = useNavigate();

  // This effect will redirect users if they are already logged in
  useEffect(() => {
    if (user) {
      navigate('/search'); // or '/' for homepage
    }
  }, [user, navigate]);


  const handleLogin = async () => {
    setError("");
    try {
      const response = await login({ email, password });
      
      // This 'if' check will now work correctly
      if (response.success) {
        console.log('Login successful, redirecting...');
        navigate('/search');
      } else {
        setError(response.error || "Invalid email or password");
      }
    } catch (err) {
      console.error('Login failed:', err);
      setError("Login failed. Please try again.");
    }
  };
  
  return (
    <Container className="d-flex flex-column align-items-center mt-5">
      <LoginForm 
        onSubmit={handleLogin} 
        email={email} 
        password={password} 
        setEmail={setEmail} 
        setPassword={setPassword} 
      />
      {error && <p className="text-danger mt-2">{error}</p>}
    </Container>
  );
};

export default LoginPage;